<ng-container *ngIf="user">
    <app-nav-bar>
        <router-outlet></router-outlet>
    </app-nav-bar>
</ng-container>
<!-- Render loading if no user yet -->
<ng-container *ngIf="!user"> Loading... </ng-container>
<p-toast position="top-right" [preventOpenDuplicates]="true"></p-toast>
